// Mobile Cart Page
// Mobile version (<768px)

import { useEffect } from 'react';
import { useCart } from '@/contexts/CartContext';
import { useNavigate } from 'react-router-dom';
import { MobileCartItem } from '@/components/mobile/cart/MobileCartItem';
import { MobileCartSummary } from '@/components/mobile/cart/MobileCartSummary';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import type { CartItem } from '@/types';
import styles from './MobileCartPage.module.css';

export default function MobileCartPage() {
  const { items, isLoading, error, refreshCart, updateQuantity, removeItem } = useCart();
  const navigate = useNavigate();

  useEffect(() => {
    // Sync cart on page load to ensure latest prices/stock
    refreshCart();
  }, [refreshCart]);

  const handleUpdateQuantity = async (itemId: string, quantity: number) => {
    try {
      await updateQuantity(itemId, quantity);
    } catch (err) {
      console.error('Failed to update quantity:', err);
    }
  };

  const handleRemoveItem = async (itemId: string) => {
    try {
      await removeItem(itemId);
    } catch (err) {
      console.error('Failed to remove item:', err);
    }
  };


  return (
    <div className={styles.mobileCartPage}>
      <MobileHeader
        title="購物車"
        showBack={false}
      />

      <div className={styles.container}>

        {isLoading && items.length === 0 ? (
          <div className={styles.loading}>載入中...</div>
        ) : error ? (
          <div className={styles.error}>{error}</div>
        ) : items.length === 0 ? (
          <div className={styles.empty}>
            <div className={styles.emptyIcon}>🛒</div>
            <p className={styles.emptyMessage}>您的購物車是空的</p>
            <button
              className={styles.shopButton}
              onClick={() => navigate('/products')}
            >
              開始購物
            </button>
          </div>
        ) : (
          <div className={styles.cartContent}>
            <div className={styles.itemsList}>
              {items.map((item: CartItem) => (
                <MobileCartItem
                  key={item.id}
                  item={item}
                  onUpdateQuantity={handleUpdateQuantity}
                  onRemove={handleRemoveItem}
                />
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Fixed Bottom Summary */}
      {items.length > 0 && <MobileCartSummary />}

      {/* Bottom Navigation */}
      <MobileBottomNav />
    </div>
  );
}
